@if (
  {
    options: (props$ | async)?.content?.options,
    tabItems: tabItems$ | async,
    selectedTabSlotId: selectedTabSlotId$ | async,
    wrapperStyles: wrapperStyles$ | async,
  };
  as context
) {
  <div class="element-wrapper" [ngStyle]="wrapperStyles$ | async">
    <div
      class="header"
      [class.size-hug]="context.options?.tabSize === 'hug'"
      [class.size-fill]="context.options?.tabSize === 'fill'"
      [class.size-fixed]="context.options?.tabSize === 'fixed'"
      [class.tabs-left]="context.options?.align === 'left'"
      [class.tabs-center]="context.options?.align === 'center'"
      [class.tabs-right]="context.options?.align === 'right'"
      [class.template-line]="context.options?.template === 'line'"
      [class.template-box]="context.options?.template === 'box'"
      [class.template-header]="context.options?.template === 'header'"
      [class.template-bubble]="context.options?.template === 'bubble'"
    >
      @for (item of context.tabItems; track trackById($index, item)) {
        <div
          class="tab"
          data-cy="Tabs:tab"
          [class.hidden-editor]="item.runtimeVisibility === 'hidden-editor'"
          [class.selected]="item.id.toString() === context.selectedTabSlotId"
          [class.icon-top]="context.options?.iconPosition === 'top'"
          [style.width]="
            context.options?.tabSize === 'fixed' ? context.options?.tabWidth : undefined
          "
          [ngStyle]="tabStyles"
          blazeClickable
          (click)="selectTab(item)"
        >
          @if (item.icon) {
            <mat-icon class="icon" [svgIcon]="item.icon" />
          }
          <div class="label">{{ item.label }}</div>
        </div>
      }
    </div>
    @if (context.selectedTabSlotId; as selectedSlotId) {
      <div #content class="content">
        <div [blazeSlotNode]="slots?.slotNodesData?.[selectedSlotId]" class="h-full">
          <ng-container *ngTemplateOutlet="slots?.templates?.[selectedSlotId] || null" />
        </div>
      </div>
    }
  </div>
}
